// eslint-disable-next-line no-use-before-define
import React from 'react';
import { closeIconBase64 } from '../../assets/base64/close-icon';
import { DrawerContainer } from './style';
export const Drawer = ({ onClose, title, isOpen, children, cancelButton, confirmButton, description, }) => {
    const handleClose = () => {
        onClose();
    };
    const handleCancel = (event) => {
        if (cancelButton.onClick) {
            cancelButton.onClick(event);
        }
        onClose();
    };
    const handleConfirm = (event) => {
        if (confirmButton.onClick) {
            confirmButton.onClick(event);
        }
        onClose();
    };
    return (React.createElement(DrawerContainer, { className: isOpen ? 'open' : 'closed' },
        React.createElement("div", { className: "root-app_drawer_overlay", onClick: handleClose }),
        React.createElement("div", { className: "root-app_drawer" },
            React.createElement("section", { className: "root-app_drawer-title_container" },
                React.createElement("div", null,
                    React.createElement("p", { className: "root-app_drawer-title_text" }, title),
                    React.createElement("p", { className: "root-app_drawer-description_text" }, description)),
                React.createElement("button", { className: "root-app_drawer-title_close_btn", onClick: handleClose },
                    React.createElement("img", { alt: "Close", title: "Close", src: closeIconBase64 }))),
            React.createElement("section", { className: "root-app_drawer-body_container" }, children),
            React.createElement("section", { className: "root-app_drawer-footer_container" },
                cancelButton && (React.createElement("button", { disabled: cancelButton.disabled, className: "root-app_drawer-footer-btn_cancel", onClick: handleCancel }, cancelButton.text)),
                confirmButton && (React.createElement("button", { disabled: confirmButton.disabled, className: "root-app_drawer-footer-btn_confirm", onClick: handleConfirm }, confirmButton.text))))));
};
//# sourceMappingURL=index.js.map